const responseCreate = {
    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'La contraseña fue actualizada exitosamente'
        }
    }
};

export const service = {
    postChangePasswordSecurity: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCreate }), 1000);
    }),
}